export default {
  appointment: {
    type: {
      individual: '個別',
      couple: '伴侶',
      parent: '親子',
      family: '家庭',
      earlytreatment: '早療/早療團體',
      supervise: '督導',
    },
    locationType: {
      inhouse: '實體',
      virtual: '遠距',
      phone: '電話',
    },
    payment: {
      notpaid: '尚未支付',
      cash: '現金支付',
      '3rdparty': '藍新金流',
      credit: '信用卡支付',
      transfer: '轉帳支付',
      project: '專案支付',
    },
    relationship: {
      single: '單身',
      inarelationship: '伴侶',
      married: '已婚',
      engaged: '訂婚',
      separate: '分居',
      divorced: '離婚',
      remarry: '再婚',
      widowed: '喪偶',
    },
    education: {
      doctor: '博士',
      master: '碩士',
      bachelor: '學士(大專院校)',
      associate: '副學士(專科)',
      seniorhigh: '高中',
      juniorhigh: '國中',
      elementary: '國小',
    },
  },
  project: {
    type: {
      mental: '心理諮詢',
      law: '法律諮詢',
      finance: '財務諮詢',
      management: '組織管理',
      medical: '健康管理',
    },
  },
  axiosErr: {
    'invalid id number': '無效的身分證字號',
    'invalid status': '已確認的財管月無法調整',
    'email has been used': 'Email 已經建立過帳號',
    'email has already been used': 'Email 已經被註冊',
    'invalid phone number': '無效的電話',
    'appointment conflicts': '同時段的空間已被預訂',
    'room has an appointment at the same time': '同時段空間已被預訂，請重新確認',
    'professional has an appointment at the same time': '專業人士同時段已經有預約',
    'id_number has been used': '身分證已重複',
    'patient has an appointment at the same time': '個案於同時間已有其他的預約',
    'invalid old password': '舊密碼錯誤',
    'insufficient attachments': '上傳個案記錄檔案不足',
    'professional has appointment or other activity': '專業人士在該時間段已有預約或其他活動',
    'room has appointment or another activity': '空間在該時間段已有預約或其他活動',
    email_conflict: 'Email 重複',
    unknown: '未知的錯誤',
    'passport has been used': '重複的護照號碼',
    'invalid gender': '無效的性別',
    'invalid education': '無效的學歷',
    'invalid relationship': '無效的感情狀態',
    'missing emergency contact information': '缺少緊急聯絡人資訊',
    'invalid emergency_contact': '無效的緊急聯絡人電話',
    // used in accounts
    'missing required fields': '缺少必須的欄位',
    'invalid role': '無效的角色',
    'admin and advstaff should not be assigned to branches': '管理員與進階個管師不需要館別',
    'invalid branches': '無效的館別',
    'phone has already been used': '電話已使用',
    'advstaff tries to update admin/advstaff': '沒有權限',
    'advstaff tries to update the role to admin/advstaff': '沒有權限',
    // 個案記錄（professional PUT /v1/appointments/<id>/record）
    'missing main requirements': '請填寫當事人主訴並至少選擇一個標籤',
    'missing evaluations': '請填寫處遇重點摘要/評估並至少選擇一個標籤',
    'missing future_plans': '請填寫處置規劃並至少選擇一個標籤',
    'mental appointments should have medical history': '議題為心理時，須填寫疾病史、評估或衡鑑結果與建議',
    'invalid main_requirement_tags': '當事人主訴含有無效的標籤',
    'invalid main evaluation_tags': '處遇重點摘要/評估含有無效的標籤',
    'invalid main future_plan_tags': '處置規劃含有無效的標籤',
    'invalid attachments': '含有不屬於此預約的附件',
    invalid_json: '資料格式錯誤',
    invalid_inputs: '輸入內容格式不正確',
    // 以下對照三個後端 repo 實際回傳的 error 字串
    forbidden: '沒有權限執行此操作',
    unauthorized: '尚未登入或連線已過期',
    'invalid payload': '資料格式錯誤',
    'invalid json': '資料格式錯誤',
    missing_required_fields: '缺少必須的欄位',
    invalid_image: '圖片格式不正確',
    invalid_avatar: '頭像格式不正確',
    missing_image: '請上傳圖片',
    internal_error: '伺服器發生錯誤，請稍後重試',
    internal_server_error: '伺服器發生錯誤，請稍後重試',
    invalid_trade_info: '金流交易資訊不正確',
    'Unprocessable Entity': '輸入內容格式不正確',
    'Not Found': '找不到資料',
    'unknown branch': '找不到館別',
    token_not_available: '連結已失效，請重新申請',
    invalid_token: '連結無效或已過期',
    stmp_error: '寄送信件失敗，請稍後重試',
    invalid_operation: '目前狀態無法執行此操作',
    invalid_fields: '欄位內容不正確',
    'invalid accounting_month': '無效的財管月',
    'invalid financial_month_str': '無效的財管月',
    file_not_found: '找不到檔案',
    'spec must be an object': '分帳設定格式不正確',
    'name and spec are required': '請填寫名稱與分帳設定',
    'receipt file is required': '請上傳收據檔案',
    project_has_been_used: '專案已被使用，無法變更',
    missing_location: '請填寫所在位置',
    invalid_rooms: '無效的空間',
    invalid_password: '密碼不正確',
    invalid_file_type: '不支援的檔案格式',
    invalid_branch: '無效的館別',
    'invalid payslip id': '找不到薪資單',
    'invalid payment type': '無效的付款方式',
    'invalid appointment id': '找不到預約',
    'invalid activity id': '找不到活動',
    duplicated_tag: '標籤名稱重複',
    'bad request': '請求內容不正確',
    'bade request': '請求內容不正確',
    activity_has_been_archived: '活動已封存，無法變更',
    'appointment has been paid': '此預約已完成付款',
    past_appointment_not_allowed: '只有管理員、派案人員與帳務人員可以新增今天以前的預約',
    availability_conflict: '資料已被其他人更新，請重新載入後再編輯',
  },
  availability: {
    // 週幾名稱：index 對應後端 weekday（1=週一…7=週日），0 不使用
    weekdayNames: ['', '週一', '週二', '週三', '週四', '週五', '週六', '週日'],
    // 即時提示（describeDay 的輸出）
    hint: {
      slots: '可排案時段：',
      slotSeparator: '、',
      unconfigured: '未設定可排案時段（全時段可排案）',
      noSlotToday: '當天不在可排案時段',
      unavailable: '不可排案',
      partialUnavailable: '不可排案時段',
      holiday: '國定假日',
    },
    // 儲存預約時的提醒原因（checkAppointmentAvailability 的輸出）
    reminder: {
      outsideSlot: '不在專業人士的可排案時段內',
      unavailable: '落在專業人士的不可排案日期',
      partialUnavailable: '落在專業人士的不可排案時段',
      holiday: '落在國定假日',
      confirmTitle: '預約時間提醒',
      confirmIntro: '此預約時間有以下提醒（僅供參考）：',
      confirmButtonCreate: '仍要建立',
      confirmButtonEdit: '仍要儲存',
      cancelButton: '否，繼續編輯',
    },
    // 行事曆圖例
    legend: {
      available: '可排案時段',
      outside: '未設定',
      off: '不可排案',
      partialOff: '部分不可排案',
      holiday: '國定假日',
    },
    // 行事曆館別篩選
    branchFilter: {
      placeholder: '篩選可排案館別',
      // 時段館別文字之間的分隔
      separator: '・',
    },
    // 不可排案原因（後端 reason），選項依此順序顯示
    reasons: {
      assigned_work: '工作衝突-所轉工作',
      self_scheduled_work: '工作衝突-自排工作',
      personal: '私人因素',
    },
    // 衝突／儲存結果
    conflict: {
      versionMismatch: '資料已被其他人更新，請重新載入後再編輯',
      appointmentsTitle: '以下預約落在不可排案日期或時段內，請聯繫相關個案',
    },
  },
  httpStatus: {
    400: '請求內容不正確',
    403: '沒有權限執行此操作',
    404: '找不到資料',
    409: '資料衝突，請重新整理後再試',
    413: '檔案過大',
    422: '輸入內容格式不正確',
    500: '伺服器發生錯誤，請稍後重試',
    502: '伺服器暫時無法連線，請稍後重試',
    503: '伺服器暫時無法連線，請稍後重試',
    504: '伺服器回應逾時，請稍後重試',
    network: '網路連線失敗，請確認網路後重試',
  },
  errorSessionExpire: '連線已過期，請重新登入',
  noPagePermission: '您沒有權限使用此頁面，已為您導回可使用的頁面',
  tag: {
    // 對照後端 admin/fixtures/appointment_record_tags.yaml（tag_type = main_requirement，
    // 去重後 71 個）與 admin/locale/zh_Hant/LC_MESSAGES/django.po 的翻譯。
    // 後端改 fixture 或翻譯時這裡要一併同步。
    main_requirement: {
      // 心理諮詢
      relationship: '情感議題/伴侶關係',
      marriage: '婚姻與家庭',
      original_family: '原生家庭',
      friendship: '一般人際',
      career: '職涯規劃',
      colleagues: '職場人際',
      pressure: '壓力管理',
      emotion: '情緒議題',
      trauma: '失落創傷',
      psychosomatic_disorder: '身心症狀',
      sexuality: '性別議題',
      life: '生活適應',
      self_harm: '自傷與傷人',
      sex_harrassment: '性侵性騷',
      child_abuse: '家暴兒虐',
      drug_abuse: '藥物濫用',
      politcal: '政治',
      sex_gender: '性別',
      culture: '文化',
      tradition: '習俗',
      religion: '宗教與靈性',
      disability: '身心障礙',
      early_treatment: '早期療育',
      mental_other: '其他',
      political: '政治', // politcal 的正確拼法別名
      // 法律諮詢
      accident_compensation: '交通事故事件(賠償)',
      conciliation: '調解或和解協議',
      labor: '勞資關係事件',
      debt_execution: '債權追償',
      enforcement_procedure: '強制執行',
      damage_remedy: '損害賠償',
      civil_litigation: '其他民事案件',
      child_adoption: '收養扶養',
      marriage_lawsuit: '婚姻事件',
      minor_children_rights: '未成年子女權利義務',
      family_wealth: '夫妻財產',
      legacy: '遺產繼承事件',
      protection_order: '民事保護令事件',
      guardian_declaration: '監護宣告',
      other_family_lawsuit: '其他家事事件',
      forgery: '偽造文書',
      accident_criminal_case: '交通事故事件(傷害)',
      harm: '傷害',
      copyright_infringement: '侵害著作權',
      defame: '妨害名譽',
      law_other: '其他',
      administrative_proceedings: '行政訴訟',
      expropriation: '不動產徵收',
      review_contract: '契約審閱',
      intellectual_property: '智慧財產權',
      // 財務諮詢
      finance_inspection: '財務健檢',
      retire_plan: '退休規劃',
      family_finance: '家庭財務',
      finance_plan: '理財規劃',
      debt_consulting: '債務諮詢',
      finance_other: '其他',
      // 組織管理
      management: '組織管理',
      profermance: '工作效能',
      organization_atomshpre: '團隊士氣',
      organization_adjust: '變革調適',
      organization_crisis: '重大危機',
      management_other: '其他',
      // 健康管理
      diagnosis: '鑑別診斷',
      preventive_healthcare: '疾病預防',
      health_check_consult: '生理檢測結果諮詢',
      work_harm_and_rehabilitation: '職業災害與復健',
      health_other: '其他',
      weight_loss_consult: '減重諮詢',
      nutrition_facts: '食品營養',
      nutritional_supplement: '保健營養',
      fitness: '健身與體適能',
      athletic_training: '運動防護',
    },
    // 主訴標籤依 record_type 分組，供下拉選單分群顯示
    main_requirement_groups: [
      {
        type: 'mental',
        label: '心理諮詢',
        tags: [
          'relationship', 'marriage', 'original_family', 'friendship', 'career', 'colleagues',
          'pressure', 'emotion', 'trauma', 'psychosomatic_disorder', 'sexuality', 'life', 'self_harm',
          'sex_harrassment', 'child_abuse', 'drug_abuse', 'politcal', 'sex_gender', 'culture',
          'tradition', 'religion', 'disability', 'early_treatment', 'mental_other',
        ],
      },
      {
        type: 'law',
        label: '法律諮詢',
        tags: [
          'accident_compensation', 'conciliation', 'labor', 'debt_execution',
          'enforcement_procedure', 'damage_remedy', 'civil_litigation', 'child_adoption',
          'marriage_lawsuit', 'minor_children_rights', 'family_wealth', 'legacy', 'protection_order',
          'guardian_declaration', 'other_family_lawsuit', 'forgery', 'accident_criminal_case',
          'harm', 'copyright_infringement', 'defame', 'law_other', 'administrative_proceedings',
          'expropriation', 'review_contract', 'intellectual_property',
        ],
      },
      {
        type: 'finance',
        label: '財務諮詢',
        tags: [
          'finance_inspection', 'retire_plan', 'family_finance', 'finance_plan', 'debt_consulting',
          'finance_other',
        ],
      },
      {
        type: 'management',
        label: '組織管理',
        tags: [
          'management', 'profermance', 'organization_atomshpre', 'organization_adjust',
          'organization_crisis', 'management_other',
        ],
      },
      {
        type: 'health',
        label: '健康管理',
        tags: [
          'diagnosis', 'preventive_healthcare', 'health_check_consult',
          'work_harm_and_rehabilitation', 'health_other', 'weight_loss_consult', 'nutrition_facts',
          'nutritional_supplement', 'fitness', 'athletic_training',
        ],
      },
    ],
    evaluation: {
      mental_low_risk: '低風險：無任何立即性風險',
      mental_medium_risk: '中度風險：雖有壓力但具有調管能力',
      mental_high_risk: '高度風險：需藉由持續性心理治療',
      mental_immediate_risk: '立即性風險：需通報、轉介相關單位或照會醫師',
    },
    future_plan: {
      mental_continue: '續談',
      mental_close: '結案',
      mental_transfer: '轉介',
      mental_present: '照會',
      mental_transform_to_self_pay: '方案轉自費',
      mental_future_plan_other: '其他',
    },
  },
  confirm_status: {
    not_confirmed: '尚未確認',
    confirmed: '已確認',
    wrong_amount: '金額錯誤',
    not_notified: '未通知',
  },
  activity_type: {
    general_lecture: '一般講座/工作坊',
    eap_lecture: 'EAP講座',
    investigation_committee: '調查委員會議',
    support_group: '安心團體',
    worry_free_lecture: '無憂講座',
    attendance_certificate: '出席證明',
    counseling_record: '諮商紀錄/摘要',
    psychological_assessment: '心理評估報告',
    education_training: '教育訓練',
    intern_activity: '實習生活動',
    group_supervision: '團督',
    internal_borrow: '內部成員借用',
  },
};
